import { create } from "zustand";

export interface PresentationGuideState {
  presentationId: string;
  stepId: string;
  stepIndex: number;
  stepCount: number;
  action?: "click" | "type" | "enter" | "drag";
  phase: "presenting" | "waiting" | "paused";
  replayCount: number;
  anchor?: { x: number; y: number; displayId: number | null };
}

// Each display runs its own presentation. Commands are broadcast, while local
// render state stays local so a mirror cannot overwrite another display's step.
export const usePresentationGuideStore = create<{
  guide: PresentationGuideState | null;
}>(() => ({ guide: null }));
